import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { Box, Button, Paper, Stack, TextField } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { formatToPhone } from 'brazilian-values';
import { toast } from 'react-toastify';
import Toast from '../../../../components/Toast';
import { options } from '../../../../helpers/toastOptions';
import { parseCpfCnpj, parsePhone } from '../../../../helpers/parseValues';
import { parseStringWithRegex } from '../../../../helpers/parseString';
import { useIntegration } from '../../../../hooks/Integration';
import { useModal } from '../../../../hooks/Modal';
import { StepButtons } from '../StepButtons';
import {
  Title,
  BtnWrapper,
  FixedButton,
  SectionTitleContainer,
  InputContainerWidthNumber,
  FieldsInLineLayout,
  SectionTitle
} from './styled';
import { ReverseCollectContext } from '../..';

export const CollectData = () => {
  const [document, setDocument] = useState('');
  const [ZipPostalCode, setZipPostalCode] = useState('');
  // const [zipSearchedByDocument, setZipSearchedByDocument] = useState('');
  const [hasInvalidZipCode, setHasInvalidZipCode] = useState(false);
  const [contactNumber, setContactNumber] = useState('');
  const [isRequiredAlternativeContact, setIsRequiredAlternativeContact] =
    useState(false);
  const [isRequiredAlternativeContact2, setIsRequiredAlternativeContact2] =
    useState(false);
  const [zipSearchedByDocument, setZipSearchedByDocument] = useState('');

  const { searchUser, getAddressByZipPostalCode } = useIntegration();
  const { closeModal } = useModal();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    handleNextStep,
    knowledgeNumber,
    collectSenderData,
    setCollectSenderData,
    selectedAddressSenderIndex,
    openChangeCollectAddressModal,
    openAddCollectAddressModal,
    disabledSenderData,
    setDisabledSenderData,
    alternativeSenderContactName,
    setAlternativeSenderContactName,
    alternativeSenderContactEmail,
    setAlternativeSenderContactEmail,
    alternativeSenderContactPhone,
    setAlternativeSenderContactPhone,
    alternativeSenderContactExtension,
    setAlternativeSenderContactExtension,
    alternativeSenderContactName2,
    setAlternativeSenderContactName2,
    alternativeSenderContactEmail2,
    setAlternativeSenderContactEmail2,
    alternativeSenderContactPhone2,
    setAlternativeSenderContactPhone2,
    alternativeSenderContactExtension2,
    setAlternativeSenderContactExtension2,
    alternativeSenderContact,
    setAlternativeSenderContact,
    alternativeSenderContact2,
    setAlternativeSenderContact2,
    disableSenderName,
    setDisableSenderName,
    disableSenderStreetAddress,
    setDisableSenderStreetAddress,
    disableSenderSuburb,
    setDisableSenderSuburb,
    isToValidateSenderDocument,
    setIsToValidateSenderDocument,
    isToValidateSenderAddressNumber,
    setIsToValidateSenderAddressNumber,
    setDataToAddCollectAddressModal,
    setEnableDeclaration,
    openLoadingModal
  } = useContext(ReverseCollectContext);

  const collectSenderSchema = Yup.object().shape({
    document: Yup.string()
      .required('CNPJ/CPF obrigatório')
      .trim('CNPJ/CPF obrigatório')
      .test('validadeDocument', 'CNPJ/CPF inválido', (value) => {
        if (isToValidateSenderDocument) {
          return (
            typeof value === 'string' &&
            [11, 14].includes(parseCpfCnpj(value)?.length)
          );
        }

        return true;
      }),
    name: Yup.string()
      .required('Razão Social / Nome obrigatório')
      .trim('Razão Social / Nome obrigatório'),
    zipPostalCode: Yup.string()
      .required('CEP obrigatório')
      .trim('CEP obrigatório')
      .test('validateZipPostalCode', 'CEP inválido', (value) => {
        const regex = /^\d{8}$/;
        return (
          value && value.replace('-', '').match(regex) && !hasInvalidZipCode
        );
      }),
    streetAddress: Yup.string()
      .required('Endereço obrigatório')
      .trim('Endereço obrigatório'),
    streetAddressNumber: Yup.string()
      .required('Número obrigatório')
      .trim('Número obrigatório')
      .test('validateStreetAddressNumber', 'Número inválido', (value) => {
        if (!!knowledgeNumber || !isToValidateSenderAddressNumber) {
          return true;
        }

        return value && value !== '0';
      }),
    additionalInformation: Yup.string().nullable(),
    suburb: Yup.string()
      .required('Bairro obrigatório')
      .trim('Bairro obrigatório'),
    city: Yup.string()
      .required('Cidade obrigatória')
      .trim('Cidade obrigatória'),
    state: Yup.string()
      .required('Estado obrigatório')
      .trim('Estado obrigatório'),
    contactName: Yup.string()
      .required('Nome obrigatório')
      .trim('Nome obrigatório'),
    contactEmail: Yup.string()
      .required('E-mail obrigatório')
      .trim('E-mail obrigatório')
      .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido'),
    phoneNumber: Yup.string()
      .required('Telefone obrigatório')
      .trim('Telefone obrigatório')
      .test('validatePhoneNumber', 'Telefone inválido', (value) => {
        return parsePhone(value).length >= 10;
      }),
    extension: Yup.string().nullable(),
    alternativeContactName: isRequiredAlternativeContact
      ? Yup.string().required('Nome obrigatório')
      : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactEmail: isRequiredAlternativeContact ? Yup.string().required('E-mail obrigatório').matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido') : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactPhone: isRequiredAlternativeContact ? Yup.string().required('Telefone obrigatório').test('validatePhoneNumber', 'Telefone inválido', (value) => value ? parsePhone(value).length >= 10 : false) : Yup.string().nullable(),
    alternativeExtension: Yup.string().nullable(),

    alternativeContactName2: isRequiredAlternativeContact2
      ? Yup.string().required('Nome obrigatório')
      : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactEmail2: isRequiredAlternativeContact2 ? Yup.string().required('E-mail obrigatório').matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido') : Yup.string(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactPhone2: isRequiredAlternativeContact2 ? Yup.string().required('Telefone obrigatório').test('validatePhoneNumber', 'Telefone inválido', (value) => value ? parsePhone(value).length >= 10 : false) : Yup.string().nullable(),
    alternativeExtension2: Yup.string().nullable()
  });

  const {
    handleSubmit,
    control,
    setValue,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(collectSenderSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });

  const getDocumentInfo = async (value) => {
    setIsToValidateSenderDocument(true);

    if (value) {
      try {
        const response = await searchUser({
          searchData: { document: parseCpfCnpj(value) }
        });

        if (response?.length > 0) {
          const userSearched = response[0];

          if (userSearched?.document) {
            const {
              name,
              zipPostalCode,
              streetAddress,
              streetAddressNumber,
              addressComplement,
              suburb,
              city,
              state
            } = userSearched;

            setValue('name', name.toUpperCase());
            setValue('zipPostalCode', zipPostalCode);
            setZipPostalCode(zipPostalCode);
            setZipSearchedByDocument(zipPostalCode);
            const newStringAddress = parseStringWithRegex({
              string: String(streetAddress).trim(),
              regex: /^[aA-zZ0-9\s]+$/
            });
            setValue('streetAddress', newStringAddress.toUpperCase());
            setValue('streetAddressNumber', streetAddressNumber);
            if (addressComplement) {
              const newStringAddressComplement = parseStringWithRegex({
                string: String(addressComplement).trim(),
                regex: /^[aA-zZ0-9\s]+$/
              });
              setValue('additionalInformation', newStringAddressComplement);
            } else {
              setValue('additionalInformation', '');
            }

            if (suburb) {
              const newStringSuburb = parseStringWithRegex({
                string: String(suburb).trim(),
                regex: /^[aA-zZ\s]+$/
              });

              setDisableSenderSuburb(true);
              setValue('suburb', newStringSuburb);
            } else {
              setDisableSenderSuburb(false);
              setValue('suburb', '');
              // setSenderSuburb('');
            }

            setValue('city', city.toUpperCase());
            setValue('state', state.toUpperCase());

            clearErrors([
              'document',
              'name',
              'zipPostalCode',
              'streetAddress',
              'streetAddressNumber',
              'additionalInformation',
              'suburb',
              'city',
              'state'
            ]);

            setHasInvalidZipCode(false);
            setDisableSenderName(true);
            setDisableSenderStreetAddress(true);
            // setDisableSenderSuburb(true);
            setIsToValidateSenderDocument(false);
            setIsToValidateSenderAddressNumber(true);
          }
        } else {
          setDisableSenderName(false);

          toast(
            <Toast
              title="Atenção!"
              content="Usuário não foi localizado com o documento informado."
              type="error"
            />,
            options
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    } else {
      setDisableSenderName(false);
      setValue('name', '');

      if (!ZipPostalCode) {
        setValue('streetAddress', '');
        setValue('streetAddressNumber', '');
        setValue('additionalInformation', '');
        setValue('suburb', '');
        setValue('city', '');
        setValue('state', '');
      }
    }
  };

  const searchAddressByZipPostalCode = async (value) => {
    const regex = /^\d{8}$/;

    if (value === zipSearchedByDocument) {
      return;
    }

    if (value.replace('-', '').match(regex)) {
      // if (value.replace('-', '') === zipSearchedByDocument) {
      //   return;
      // }

      try {
        const data = await getAddressByZipPostalCode({
          zipPostalCode: value.replace('-', '')
        });

        if (data) {
          const clear = ['zipPostalCode'];

          setHasInvalidZipCode(false);

          if (data.streetAddress) {
            const newStringAddress = parseStringWithRegex({
              string: String(data.streetAddress).trim(),
              regex: /^[aA-zZ0-9\s]+$/
            });

            if (newStringAddress) {
              setValue('streetAddress', newStringAddress.toUpperCase());
              clear.push('streetAddress');
              setDisableSenderStreetAddress(true);
            } else {
              setValue('streetAddress', '');
              setDisableSenderStreetAddress(false);
            }
          } else {
            setValue('streetAddress', '');
            setDisableSenderStreetAddress(false);
          }

          if (data.suburb) {
            const newStringSuburb = parseStringWithRegex({
              string: String(data.suburb).trim(),
              regex: /^[aA-zZ\s]+$/
            });

            if (newStringSuburb) {
              setValue('suburb', newStringSuburb?.toUpperCase());
              clear.push('suburb');
              setDisableSenderSuburb(true);
            } else {
              setValue('suburb', '');
              setDisableSenderSuburb(false);
            }
          } else {
            setValue('suburb', '');
            setDisableSenderSuburb(false);
          }

          if (data.city) {
            setValue('city', data.city.toUpperCase());
            clear.push('city');
          } else {
            setValue('city', '');
          }

          if (data.state) {
            setValue('state', data.state.toUpperCase());
            clear.push('state');
          } else {
            setValue('state', '');
          }

          setValue('streetAddressNumber', '');
          setValue('additionalInformation', '');

          clearErrors(clear);
        } else {
          setError('zipPostalCode', {
            message: 'CEP inválido'
          });
          setHasInvalidZipCode(true);
          setDisableSenderStreetAddress(true);
          setDisableSenderSuburb(true);
          setValue('streetAddress', '');
          setValue('streetAddressNumber', '');
          setValue('additionalInformation', '');
          setValue('suburb', '');
          setValue('city', '');
          setValue('state', '');

          toast(
            <Toast
              title="Atenção!"
              content="O CEP informado não foi localizado."
              type="error"
            />,
            options
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    } else {
      setHasInvalidZipCode(true);
      setDisableSenderStreetAddress(true);
      setDisableSenderSuburb(true);
      setValue('streetAddress', '');
      setValue('streetAddressNumber', '');
      setValue('additionalInformation', '');
      setValue('suburb', '');
      setValue('city', '');
      setValue('state', '');
    }
  };

  const onNextStep = async (data) => {
    // if (alternativeContactIsRequired) {
    //   let stopNextStep = false;

    //   if (data.alternativeContactName === '') {
    //     stopNextStep = true;
    //     setError('alternativeContactName', { message: 'Nome obrigatório' });
    //   }

    //   if (data.alternativeContactEmail === '') {
    //     stopNextStep = true;
    //     setError('alternativeContactEmail', { message: 'E-mail obrigatório' });
    //   }

    //   if (data.alternativePhoneNumber === '') {
    //     stopNextStep = true;
    //     setError('alternativePhoneNumber', {
    //       message: 'Telefone obrigatório'
    //     });
    //   }

    //   if (stopNextStep) {
    //     return;
    //   }
    // }

    try {
      openLoadingModal();

      const getAddressResponse = await getAddressByZipPostalCode({
        zipPostalCode: parseCpfCnpj(data.zipPostalCode)
      });

      if (
        !getAddressResponse ||
        (isToValidateSenderAddressNumber &&
          (!data?.streetAddressNumber || data?.streetAddressNumber === '0'))
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="Atualizar os dados dos campos destacados em vermelho."
            type="error"
          />,
          options
        );

        setDataToAddCollectAddressModal({
          document: data?.document ? parseCpfCnpj(data?.document) : '',
          name: data?.name || '',
          zipPostalCode: data?.zipPostalCode
            ? parseCpfCnpj(data?.zipPostalCode)
            : '',
          streetAddress: data?.streetAddress || '',
          streetAddressNumber: data?.streetAddressNumber || '',
          additionalInformation: data?.additionalInformation || '',
          suburb: data?.suburb || '',
          city: data?.city || '',
          state: data?.state || '',
          hasInvalidZipCode: !getAddressResponse,
          hasInvalidStreetAddressNumber:
            !data?.streetAddressNumber || data?.streetAddressNumber === '0'
        });

        openAddCollectAddressModal();

        return;
      }

      setEnableDeclaration(false);

      const response = await searchUser({
        searchData: {
          document: parseCpfCnpj(data.document)
        }
      });

      if (response?.length > 0) {
        const userSearched = response[0];

        if (userSearched?.document) {
          const { declaration } = userSearched;

          if (declaration === 'S') {
            setEnableDeclaration(true);
          }
        }
      }

      closeModal();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      closeModal();
    }

    const contactList = [];

    contactList.push({
      name: data.contactName,
      phoneNumber: parsePhone(data.phoneNumber),
      extension: data.extension,
      email: data.contactEmail
    });

    alternativeSenderContact &&
      isRequiredAlternativeContact &&
      contactList.push({
        name: data.alternativeContactName,
        phoneNumber: parsePhone(data.alternativeContactPhone),
        extension: data.alternativeExtension,
        email: data.alternativeContactEmail
      });

    alternativeSenderContact2 &&
      isRequiredAlternativeContact &&
      contactList.push({
        name: data.alternativeContactName2,
        phoneNumber: parsePhone(data.alternativeContactPhone2),
        extension: data.alternativeExtension2,
        email: data.alternativeContactEmail2
      });

    const collectData = {
      document: parseCpfCnpj(data.document),
      name: data.name,
      address: {
        zipPostalCode: parseCpfCnpj(data.zipPostalCode),
        streetAddress: data.streetAddress,
        streetAddressNumber: data.streetAddressNumber,
        suburb: data.suburb,
        city: data.city,
        state: data.state,
        country: data.country || 'BRASIL',
        additionalInformation: data.additionalInformation || ''
      },
      contactList
    };

    setCollectSenderData(collectData);

    handleNextStep();
  };

  useEffect(() => {
    if (
      alternativeSenderContactName !== '' ||
      alternativeSenderContactEmail !== '' ||
      alternativeSenderContactPhone !== ''
    ) {
      setAlternativeSenderContact(true);
    }

    if (
      alternativeSenderContactName2 !== '' ||
      alternativeSenderContactEmail2 !== '' ||
      alternativeSenderContactPhone2 !== ''
    ) {
      setAlternativeSenderContact2(true);
    }
  }, []);

  const addContact = () => {
    if (alternativeSenderContact === true) {
      setAlternativeSenderContact2(true);
    }

    if (alternativeSenderContact === false) {
      setAlternativeSenderContact(true);
    }
  };

  const removeContactAlternative = () => {
    setAlternativeSenderContactName('');
    setAlternativeSenderContactEmail('');
    setAlternativeSenderContactPhone('');
    setAlternativeSenderContactExtension('');
    setValue('alternativeContactName', '');
    setValue('alternativeContactEmail', '');
    setValue('alternativeContactPhone', '');
    setValue('alternativeContactExtension', '');
  };

  const removeContactAlternative2 = () => {
    setAlternativeSenderContactName2('');
    setAlternativeSenderContactEmail2('');
    setAlternativeSenderContactPhone2('');
    setAlternativeSenderContactExtension2('');
    setValue('alternativeContactName2', '');
    setValue('alternativeContactEmail2', '');
    setValue('alternativeContactPhone2', '');
    setValue('alternativeContactExtension2', '');
  };

  useEffect(() => {
    if (
      alternativeSenderContactName !== '' ||
      alternativeSenderContactEmail !== '' ||
      alternativeSenderContactPhone !== '' ||
      alternativeSenderContactExtension !== ''
    ) {
      setIsRequiredAlternativeContact(true);
    } else {
      setIsRequiredAlternativeContact(false);
      clearErrors([
        'alternativeContactName',
        'alternativeContactEmail',
        'alternativeContactPhone'
      ]);
    }
  }, [
    alternativeSenderContactName,
    alternativeSenderContactEmail,
    alternativeSenderContactPhone,
    alternativeSenderContactExtension
  ]);

  useEffect(() => {
    if (
      alternativeSenderContactName2 !== '' ||
      alternativeSenderContactEmail2 !== '' ||
      alternativeSenderContactPhone2 !== '' ||
      alternativeSenderContactExtension2 !== ''
    ) {
      setIsRequiredAlternativeContact2(true);
    } else {
      setIsRequiredAlternativeContact2(false);
      clearErrors([
        'alternativeContactName2',
        'alternativeContactEmail2',
        'alternativeContactPhone2'
      ]);
    }
  }, [
    alternativeSenderContactName2,
    alternativeSenderContactEmail2,
    alternativeSenderContactPhone2,
    alternativeSenderContactExtension2
  ]);

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#document').mask(cpf.length > 14 ? masks[1] : masks[0], op);
      }
    };

    $('#document').length > 11
      ? $('#document').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#document').mask('000.000.000-00#', cpfCnpjOptions);
  }, [document]);

  useEffect(() => {
    $('#zipPostalCode').mask('00000-000');
  }, [ZipPostalCode]);

  useEffect(() => {
    $('#phoneNumber').mask('(00) 0000-00009');
  }, [contactNumber]);

  useEffect(() => {
    $('#alternativePhoneNumber').mask('(00) 0000-00009');
  }, [alternativeSenderContactPhone]);

  // useEffect(() => {
  //   const isRequired = isFilled();
  //   setAlternativeContactIsRequired(isRequired);

  //   if (!isRequired) {
  //     clearErrors([
  //       'alternativeContactName',
  //       'alternativeContactEmail',
  //       'alternativePhoneNumber',
  //       'alternativeExtension'
  //     ]);
  //   }
  // }, [
  //   alternativeContactName,
  //   alternativeContactEmail,
  //   alternativeContactNumber,
  //   alternativeContactExtension
  // ]);

  useEffect(() => {
    collectSenderData?.document &&
      setValue('document', collectSenderData?.document);
    collectSenderData?.name &&
      setValue('name', collectSenderData?.name.toUpperCase());
    collectSenderData?.address?.zipPostalCode &&
      setValue('zipPostalCode', collectSenderData?.address?.zipPostalCode);
    collectSenderData?.address?.streetAddress &&
      setValue(
        'streetAddress',
        collectSenderData?.address?.streetAddress.toUpperCase()
      );
    collectSenderData?.address?.streetAddressNumber &&
      setValue(
        'streetAddressNumber',
        collectSenderData?.address?.streetAddressNumber
      );
    if (collectSenderData?.address?.additionalInformation) {
      const newStringAddressComplement = parseStringWithRegex({
        // eslint-disable-next-line prettier/prettier
        string: String(collectSenderData?.address?.additionalInformation).trim(),
        regex: /^[aA-zZ0-9\s]+$/
      });
      setValue(
        'additionalInformation',
        newStringAddressComplement.toUpperCase()
      );
    } else {
      setValue('additionalInformation', '');
    }
    // eslint-disable-next-line prettier/prettier
    // collectSenderData?.address?.additionalInformation ? setValue('additionalInformation', collectSenderData?.address?.additionalInformation.toUpperCase()) : setValue('additionalInformation', '');

    if (collectSenderData?.address?.suburb) {
      const newStringSuburb = parseStringWithRegex({
        string: String(collectSenderData?.address?.suburb).trim(),
        regex: /^[aA-zZ\s]+$/
      });

      if (newStringSuburb) {
        setValue('suburb', newStringSuburb?.toUpperCase());
        setDisableSenderSuburb(true);
      } else {
        setValue('suburb', '');
        setDisableSenderSuburb(false);
      }
    } else {
      setValue('suburb', '');
      setDisableSenderSuburb(false);
    }
    // collectSenderData?.address?.suburb &&
    //   setValue('suburb', collectSenderData?.address?.suburb.toUpperCase());
    collectSenderData?.address?.city &&
      setValue('city', collectSenderData?.address?.city.toUpperCase());
    collectSenderData?.address?.state &&
      setValue('state', collectSenderData?.address?.state.toUpperCase());

    collectSenderData?.document && setDocument(collectSenderData?.document);
    collectSenderData?.address?.zipPostalCode &&
      setZipPostalCode(collectSenderData?.address?.zipPostalCode);
  }, [selectedAddressSenderIndex]);

  useEffect(() => {
    collectSenderData?.document &&
      setValue('document', collectSenderData?.document);
    collectSenderData?.name &&
      setValue('name', collectSenderData?.name.toUpperCase());
    collectSenderData?.address?.zipPostalCode &&
      setValue('zipPostalCode', collectSenderData?.address?.zipPostalCode);
    if (collectSenderData?.address?.streetAddress) {
      const newStringAddress = parseStringWithRegex({
        string: String(collectSenderData?.address?.streetAddress).trim(),
        regex: /^[aA-zZ0-9\s]+$/
      });

      if (newStringAddress) {
        setValue('streetAddress', newStringAddress.toUpperCase());
      } else {
        setValue('streetAddress', '');
      }
    } else {
      setValue('streetAddress', '');
    }
    // collectSenderData?.address?.streetAddress &&
    //   setValue(
    //     'streetAddress',
    //     collectSenderData?.address?.streetAddress.toUpperCase()
    //   );
    collectSenderData?.address?.streetAddressNumber &&
      setValue(
        'streetAddressNumber',
        collectSenderData?.address?.streetAddressNumber
      );
    if (collectSenderData?.address?.additionalInformation) {
      const newStringAddressComplement = parseStringWithRegex({
        // eslint-disable-next-line prettier/prettier
        string: String(collectSenderData?.address?.additionalInformation).trim(),
        regex: /^[aA-zZ0-9\s]+$/
      });
      setValue(
        'additionalInformation',
        newStringAddressComplement.toUpperCase()
      );
    } else {
      setValue('additionalInformation', '');
    }
    if (collectSenderData?.address?.suburb) {
      const newStringSuburb = parseStringWithRegex({
        string: String(collectSenderData?.address?.suburb).trim(),
        regex: /^[aA-zZ\s]+$/
      });

      if (newStringSuburb) {
        setValue('suburb', newStringSuburb?.toUpperCase());
        setDisableSenderSuburb(true);
        if (
          !collectSenderData?.address?.suburb.match(/^[aA-zZ\s]+$/) &&
          collectSenderData?.address?.suburb.suburb !== ''
        ) {
          setDisableSenderSuburb(false);
        }
      } else {
        setValue('suburb', '');
        setDisableSenderSuburb(false);
      }
    } else {
      setValue('suburb', '');
      setDisableSenderSuburb(false);
    }
    // collectSenderData?.address?.suburb &&
    //   setValue('suburb', collectSenderData?.address?.suburb.toUpperCase());
    collectSenderData?.address?.city &&
      setValue('city', collectSenderData?.address?.city.toUpperCase());
    collectSenderData?.address?.state &&
      setValue('state', collectSenderData?.address?.state.toUpperCase());

    collectSenderData?.document && setDocument(collectSenderData?.document);
    collectSenderData?.address?.zipPostalCode &&
      setZipPostalCode(collectSenderData?.address?.zipPostalCode);

    if (collectSenderData?.contactList?.length > 0) {
      collectSenderData?.contactList[0]?.name &&
        setValue(
          'contactName',
          collectSenderData?.contactList[0]?.name.toUpperCase() || ''
        );
      collectSenderData?.contactList[0]?.email &&
        setValue(
          'contactEmail',
          collectSenderData?.contactList[0]?.email.toLowerCase()
        );
      collectSenderData?.contactList[0]?.phoneNumber &&
        setValue('phoneNumber', collectSenderData?.contactList[0]?.phoneNumber);
      collectSenderData?.contactList[0]?.phoneNumber &&
        setContactNumber(collectSenderData?.contactList[0]?.phoneNumber);
      collectSenderData?.contactList[0]?.extension &&
        setValue(
          'extension',
          collectSenderData?.contactList[0]?.extension || ''
        );
    }

    if (collectSenderData?.contactList?.length > 1) {
      setAlternativeSenderContact(true);
      setValue('alternativeContact', true);
      setValue(
        'alternativeContactName',
        collectSenderData?.contactList[1]?.name.toUpperCase()
      );
      setValue(
        'alternativeContactEmail',
        collectSenderData?.contactList[1]?.email.toLowerCase()
      );
      setValue(
        'alternativeContactPhone',
        collectSenderData?.contactList[1]?.phoneNumber
      );
      setValue(
        'alternativeExtension',
        collectSenderData?.contactList[1]?.extension
      );
    } else {
      setAlternativeSenderContact(false);
    }

    if (collectSenderData?.contactList?.length > 2) {
      setAlternativeSenderContact2(true);
      setValue('alternativeContact2', true);
      setValue(
        'alternativeContactName2',
        collectSenderData?.contactList[2]?.name.toUpperCase()
      );
      setValue(
        'alternativeContactEmail2',
        collectSenderData?.contactList[2]?.email.toLowerCase()
      );
      setValue(
        'alternativeContactPhone2',
        collectSenderData?.contactList[2]?.phoneNumber
      );
      setValue(
        'alternativeExtension2',
        collectSenderData?.contactList[2]?.extension
      );
    } else {
      setAlternativeSenderContact2(false);
    }
  }, []);

  return (
    <form onSubmit={handleSubmit(onNextStep)}>
      <Paper
        elevation={2}
        style={{
          position: 'relative',
          marginTop: 16,
          padding: '20px 16px 16px'
        }}
      >
        <Stack
          direction={maxSM ? 'column' : 'row'}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: maxSM ? 16 : 0
          }}
        >
          <Title>Dados da Coleta:</Title>

          {!!knowledgeNumber && (
            <Button
              type="button"
              variant="contained"
              style={{ marginTop: -8 }}
              onClick={() => openChangeCollectAddressModal()}
            >
              Alterar
            </Button>
          )}
        </Stack>

        <Stack style={{ marginTop: knowledgeNumber ? 14 : 24 }}>
          <Stack spacing={2}>
            <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
              <Controller
                name="document"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    label="CNPJ / CPF *"
                    id="document"
                    style={{
                      minWidth: 240,
                      ':disabled': { color: '#444444' }
                    }}
                    {...field}
                    disabled={!!knowledgeNumber || !!disabledSenderData}
                    value={(field.value = document)}
                    onChange={(e) => {
                      setIsToValidateSenderDocument(true);
                      setDocument(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      getDocumentInfo(e.target.value);
                      setDocument(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    error={!!errors.document}
                    helperText={errors.document?.message}
                  />
                )}
              />

              <Controller
                name="name"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Razão Social/Nome *"
                    style={{ width: '100%' }}
                    {...field}
                    disabled={
                      !!knowledgeNumber ||
                      disableSenderName ||
                      !!disabledSenderData
                    }
                    onChange={(e) => {
                      const regex = /^[aA-zZ0-9\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.name}
                    helperText={errors.name?.message}
                  />
                )}
              />
            </Stack>

            <Stack direction={maxSM ? 'column' : 'row'} spacing={2}>
              <Controller
                name="zipPostalCode"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="CEP *"
                    id="zipPostalCode"
                    style={{ width: !maxMD && 240 }}
                    inputProps={{ maxLength: 9 }}
                    {...field}
                    disabled={!!knowledgeNumber || !!disabledSenderData}
                    value={(field.value = ZipPostalCode)}
                    onChange={(e) => {
                      setHasInvalidZipCode(true);
                      setZipPostalCode(e.target.value);
                      field.onChange(e.target.value);
                      setZipPostalCode(e.target.value);
                    }}
                    onBlur={(e) => {
                      const { value } = e.target;
                      searchAddressByZipPostalCode(value);

                      setZipPostalCode(value);
                      field.onBlur(field.onChange(value));
                    }}
                    error={!!errors.zipPostalCode}
                    helperText={errors.zipPostalCode?.message}
                  />
                )}
              />

              <Controller
                name="streetAddress"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Endereço *"
                    style={{ width: maxMD && '100%', flex: !maxMD && '1' }}
                    {...field}
                    disabled={
                      !!knowledgeNumber ||
                      !!disableSenderStreetAddress ||
                      !!disabledSenderData
                    }
                    onChange={(e) => {
                      const regex = /^[aA-zZ0-9\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.streetAddress}
                    helperText={errors.streetAddress?.message}
                  />
                )}
              />

              <Controller
                name="streetAddressNumber"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Número *"
                    style={{ width: maxSM ? '100%' : 96, minWidth: 96 }}
                    {...field}
                    disabled={!!knowledgeNumber || !!disabledSenderData}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }

                      setIsToValidateSenderAddressNumber(false);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    inputProps={{ maxLength: 50 }}
                    error={!!errors.streetAddressNumber}
                    helperText={errors.streetAddressNumber?.message}
                  />
                )}
              />
            </Stack>

            <Stack direction={maxSM ? 'column' : 'row'} spacing={2}>
              <Stack
                direction={maxSM ? 'column' : 'row'}
                spacing={2}
                style={{ width: maxMD ? '100%' : '55%' }}
              >
                <Controller
                  name="additionalInformation"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Complemento"
                      style={{ width: !maxMD && 240 }}
                      {...field}
                      disabled={!!knowledgeNumber || !!disabledSenderData}
                      onChange={(e) => {
                        const regex = /^[aA-zZ0-9\s]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 256 }}
                      error={!!errors.additionalInformation}
                      helperText={errors.additionalInformation?.message}
                    />
                  )}
                />

                <Controller
                  name="suburb"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Bairro *"
                      style={{ flex: !maxMD && '1' }}
                      {...field}
                      disabled={!!knowledgeNumber || !!disableSenderSuburb}
                      onChange={(e) => {
                        const regex = /^[aA-zZ\s]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.suburb}
                      helperText={errors.suburb?.message}
                    />
                  )}
                />
              </Stack>

              <Stack
                direction="row"
                spacing={2}
                style={{ width: maxMD ? '100%' : '45%' }}
              >
                <Controller
                  name="city"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Cidade *"
                      style={{ flex: !maxMD && '1' }}
                      {...field}
                      disabled
                      onChange={(e) => {
                        const regex = /^[aA-zZ0-9\s]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.city}
                      helperText={errors.city?.message}
                    />
                  )}
                />

                <Controller
                  name="state"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="UF *"
                      style={{ width: 96, minWidth: 96 }}
                      {...field}
                      disabled
                      onChange={(e) => {
                        const regex = /^[aA-zZ\s]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 2 }}
                      error={!!errors.state}
                      helperText={errors.state?.message}
                    />
                  )}
                />
              </Stack>
            </Stack>

            <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={maxSM ? 1 : 0}
              style={{
                height: !maxSM && 36.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: maxSM ? 'inherit' : 'center',
                marginTop: 24
              }}
            >
              <Title>Contato:</Title>

              <BtnWrapper>
                <FixedButton
                  type="button"
                  onClick={() => addContact()}
                  disabled={
                    !!(alternativeSenderContact && alternativeSenderContact2)
                  }
                  variant="contained"
                  className="btnResponsive"
                >
                  Adicionar Contato Alternativo
                </FixedButton>
              </BtnWrapper>
            </Stack>

            <Stack
              direction={maxMD ? 'column' : 'row'}
              spacing={2}
              style={{ width: '100%' }}
            >
              <Controller
                name="contactName"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Nome *"
                    fullWidth
                    {...field}
                    onChange={(e) => {
                      const { value } = e.target;
                      const regex = /^[aA-zZ\s]+$/;

                      if (!value.match(regex) && value !== '') {
                        return;
                      }

                      field.onChange(value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.contactName}
                    helperText={errors.contactName?.message}
                  />
                )}
              />

              <Controller
                name="contactEmail"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="E-mail *"
                    fullWidth
                    {...field}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.contactEmail}
                    helperText={errors.contactEmail?.message}
                  />
                )}
              />

              <Stack direction="row" spacing={2} style={{ width: '100%' }}>
                <Controller
                  name="phoneNumber"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Telefone *"
                      id="phoneNumber"
                      fullWidth
                      {...field}
                      value={(field.value = formatToPhone(contactNumber))}
                      onChange={(e) => {
                        setContactNumber(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      onBlur={(e) => {
                        if (e.target.value.length > 14) {
                          $('#phoneNumber').mask('(00) 00000-0009');
                        } else {
                          $('#phoneNumber').mask('(00) 0000-00009');
                        }

                        setContactNumber(e.target.value);
                        field.onBlur(field.onChange(e.target.value));
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.phoneNumber}
                      helperText={errors.phoneNumber?.message}
                    />
                  )}
                />

                <Controller
                  name="extension"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Ramal"
                      style={{ width: 96, minWidth: 96 }}
                      {...field}
                      onChange={(e) => {
                        const regex = /^[0-9]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }

                        field.onChange(e.target.value);
                      }}
                      onBlur={(e) => {
                        field.onBlur(field.onChange(e.target.value));
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.extension}
                      helperText={errors.extension?.message}
                    />
                  )}
                />
              </Stack>
            </Stack>
            {alternativeSenderContact && (
              <>
                <br />
                <SectionTitleContainer>
                  <SectionTitle className="titleContactResponsive">
                    Contato alternativo
                  </SectionTitle>
                  <FixedButton
                    type="button"
                    onClick={(e) => {
                      setAlternativeSenderContact(!alternativeSenderContact);
                      removeContactAlternative();
                    }}
                    variant="contained"
                    className="btnResponsive"
                  >
                    Remover Contato Alternativo
                  </FixedButton>
                </SectionTitleContainer>
                <FieldsInLineLayout className="lineResponsive">
                  <Controller
                    name="alternativeContactName"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        error={!!errors?.alternativeContactName?.message}
                        helperText={errors?.alternativeContactName?.message}
                        id="alternative_contact_name"
                        label={isRequiredAlternativeContact ? 'Nome *' : 'Nome'}
                        type="text"
                        fullWidth
                        value={(field.value = alternativeSenderContactName)}
                        onChange={(e) => {
                          const regex = /^[aA-zZ\s]+$/;
                          if (
                            !e.target.value.match(regex) &&
                            e.target.value !== ''
                          ) {
                            return;
                          }
                          setAlternativeSenderContactName(
                            e.target.value.toUpperCase()
                          );
                          field.onChange(e.target.value.toUpperCase());
                        }}
                        onBlur={(e) => {
                          setAlternativeSenderContactName(
                            e.target.value.toUpperCase().trim()
                          );
                          field.onBlur(
                            field.onChange(e.target.value.toUpperCase().trim())
                          );
                        }}
                        inputProps={{
                          maxLength: 256,
                          style: { textTransform: 'uppercase' }
                        }}
                      />
                    )}
                  />
                  <Controller
                    name="alternativeContactEmail"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="alternative_contact_mail"
                        label={
                          isRequiredAlternativeContact ? 'E-mail *' : 'E-mail'
                        }
                        {...field}
                        error={!!errors?.alternativeContactEmail?.message}
                        helperText={errors?.alternativeContactEmail?.message}
                        type="email"
                        value={(field.value = alternativeSenderContactEmail)}
                        onChange={(e) => {
                          setAlternativeSenderContactEmail(e.target.value);
                          field.onChange(e.target.value);
                        }}
                        onBlur={(e) => {
                          setAlternativeSenderContactEmail(
                            e.target.value.toLowerCase()
                          );
                          field.onBlur(
                            field.onChange(e.target.value.toLowerCase())
                          );
                        }}
                        fullWidth
                        inputProps={{ maxLength: 256 }}
                      />
                    )}
                  />
                  <Controller
                    name="alternativeContactPhone"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        error={!!errors?.alternativeContactPhone?.message}
                        helperText={errors?.alternativeContactPhone?.message}
                        id="alternativeContactPhone"
                        label={
                          isRequiredAlternativeContact
                            ? 'DDD + Telefone *'
                            : 'DDD + Telefone'
                        }
                        value={
                          (field.value = formatToPhone(
                            alternativeSenderContactPhone
                          ))
                        }
                        onChange={(e) => {
                          setAlternativeSenderContactPhone(e.target.value);
                          field.onChange(e.target.value);
                        }}
                        onBlur={(e) => {
                          if (e.target.value.length > 14) {
                            $('#alternativeContactPhone').mask(
                              '(00) 00000-0009'
                            );
                          } else {
                            $('#alternativeContactPhone').mask(
                              '(00) 0000-00009'
                            );
                          }
                          field.onBlur(field.onChange(e.target.value));
                          setAlternativeSenderContactPhone(e.target.value);
                        }}
                        fullWidth
                        inputProps={{ maxLength: 50 }}
                        className="telResponsive"
                      />
                    )}
                  />
                  <InputContainerWidthNumber>
                    <Controller
                      name="alternativeExtension"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          error={!!errors?.alternativeExtension?.message}
                          helperText={errors?.alternativeExtension?.message}
                          id="alternative_contact_ramal"
                          label="Ramal"
                          fullWidth
                          value={
                            (field.value = alternativeSenderContactExtension)
                          }
                          onChange={(e) => {
                            const regex = /^[0-9]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }
                            setAlternativeSenderContactExtension(
                              e.target.value
                            );
                            field.onChange(e.target.value);
                          }}
                          onBlur={(e) => {
                            setAlternativeSenderContactExtension(
                              e.target.value
                            );
                            field.onBlur(field.onChange(e.target.value));
                          }}
                          inputProps={{ maxLength: 50 }}
                          sx={{ minWidth: '110px' }}
                        />
                      )}
                    />
                  </InputContainerWidthNumber>
                </FieldsInLineLayout>
              </>
            )}
            {alternativeSenderContact2 && (
              <>
                <br />
                <SectionTitleContainer className="titleContactResponsive">
                  <SectionTitle>Contato alternativo</SectionTitle>
                  <FixedButton
                    type="button"
                    onClick={() => {
                      setAlternativeSenderContact2(!alternativeSenderContact2);
                      removeContactAlternative2();
                    }}
                    variant="contained"
                    className="btnResponsive"
                  >
                    Remover Contato Alternativo
                  </FixedButton>
                </SectionTitleContainer>
                <FieldsInLineLayout className="lineResponsive">
                  <Controller
                    name="alternativeContactName2"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        error={!!errors?.alternativeContactName2?.message}
                        helperText={errors?.alternativeContactName2?.message}
                        id="alternative_contact_name2"
                        label={
                          isRequiredAlternativeContact2 ? 'Nome *' : 'Nome'
                        }
                        type="text"
                        fullWidth
                        value={(field.value = alternativeSenderContactName2)}
                        onChange={(e) => {
                          const regex = /^[aA-zZ\s]+$/;
                          if (
                            !e.target.value.match(regex) &&
                            e.target.value !== ''
                          ) {
                            return;
                          }
                          setAlternativeSenderContactName2(e.target.value);
                          field.onChange(e.target.value);
                        }}
                        onBlur={(e) => {
                          setAlternativeSenderContactName2(
                            e.target.value.toUpperCase().trim()
                          );
                          field.onBlur(
                            field.onChange(e.target.value.toUpperCase().trim())
                          );
                        }}
                        inputProps={{
                          maxLength: 256,
                          style: { textTransform: 'uppercase' }
                        }}
                      />
                    )}
                  />
                  <Controller
                    name="alternativeContactEmail2"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        error={!!errors?.alternativeContactEmail2?.message}
                        helperText={errors?.alternativeContactEmail2?.message}
                        id="alternative_contact_mail2"
                        label={
                          isRequiredAlternativeContact2 ? 'E-mail *' : 'E-mail'
                        }
                        type="email"
                        fullWidth
                        value={(field.value = alternativeSenderContactEmail2)}
                        onChange={(e) => {
                          setAlternativeSenderContactEmail2(e.target.value);
                          field.onChange(e.target.value);
                        }}
                        onBlur={(e) => {
                          setAlternativeSenderContactEmail2(
                            e.target.value.toLowerCase()
                          );
                          field.onBlur(
                            field.onChange(e.target.value.toLowerCase())
                          );
                        }}
                        inputProps={{ maxLength: 256 }}
                      />
                    )}
                  />
                  <Controller
                    name="alternativeContactPhone2"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        error={!!errors?.alternativeContactPhone2?.message}
                        helperText={errors?.alternativeContactPhone2?.message}
                        id="alternativeContactPhone2"
                        label={
                          isRequiredAlternativeContact2
                            ? 'DDD + Telefone *'
                            : 'DDD + Telefone'
                        }
                        type="text"
                        fullWidth
                        value={
                          (field.value = formatToPhone(
                            alternativeSenderContactPhone2
                          ))
                        }
                        onChange={(e) => {
                          setAlternativeSenderContactPhone2(e.target.value);
                          field.onChange(e.target.value);
                        }}
                        onBlur={(e) => {
                          if (e.target.value.length > 14) {
                            $('#alternativeContactPhone2').mask(
                              '(00) 00000-0009'
                            );
                          } else {
                            $('#alternativeContactPhone2').mask(
                              '(00) 0000-00009'
                            );
                          }
                          field.onBlur(field.onChange(e.target.value));
                          setAlternativeSenderContactPhone2(e.target.value);
                        }}
                        inputProps={{ maxLength: 50 }}
                        className="telResponsive"
                      />
                    )}
                  />
                  <InputContainerWidthNumber>
                    <Controller
                      name="alternativeExtension2"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          error={!!errors?.alternativeExtension2?.message}
                          helperText={errors?.alternativeExtension2?.message}
                          id="alternative_contact_ramal2"
                          label="Ramal"
                          fullWidth
                          value={
                            (field.value = alternativeSenderContactExtension2)
                          }
                          onChange={(e) => {
                            const regex = /^[0-9]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }
                            setAlternativeSenderContactExtension2(
                              e.target.value
                            );
                            field.onChange(e.target.value);
                          }}
                          inputProps={{ maxLength: 50 }}
                          sx={{ minWidth: '110px' }}
                        />
                      )}
                    />
                  </InputContainerWidthNumber>
                </FieldsInLineLayout>
              </>
            )}
          </Stack>
        </Stack>
      </Paper>

      <StepButtons nextFunction={handleSubmit(onNextStep)} />
    </form>
  );
};
